import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { ThemeProvider, createTheme } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Login from "./components/Login"
import Dashboard from "./components/Dashboard"
import QrExport from "./components/QrExport"
import ScanEvents from "./components/ScanEvents"
import Redirect from "./components/Redirect"
import PrivateRoute from "./components/PrivateRoute"
import "./styles/Dashboard.css"

const theme = createTheme({
  palette: {
    primary: {
      main: "#6366f1",
      light: "#818cf8",
      dark: "#4f46e5",
    },
    secondary: {
      main: "#10b981",
    },
    background: {
      default: "#f9fafb",
    },
    text: {
      primary: "#1f2937",
      secondary: "#6b7280",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 700,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 8,
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 8,
        textTransform: "none",
        padding: "8px 16px",
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: 8,
      },
    },
    MuiTextField: {
      root: {
        "& .MuiOutlinedInput-root": {
          borderRadius: 8,
        },
      },
    },
  },
})

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Switch>
          {/* Ruta para el login */}
          <Route exact path="/" component={Login} />
          <Route exact path="/login" component={Login} />

          {/* Ruta para el dashboard - debe ir ANTES de la ruta comodín */}
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PrivateRoute path="/admin" component={Dashboard} />
          <PrivateRoute path="/export" component={QrExport} />
          <PrivateRoute path="/scans" component={ScanEvents} />

          {/* Ruta para redirección con GTIN */}
          <Route path="/:id/:gtin" component={Redirect} />

          {/* Ruta para redirección directa desde la raíz - debe ir DESPUÉS de las rutas específicas */}
          <Route path="/:id" component={Redirect} />
        </Switch>
      </Router>
    </ThemeProvider>
  )
}

export default App
